import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
export default {
  inheritAttrs: false,
  components: {},
  props: ["houseId", "userId"],
  data: function data() {
    return {
      disLoading: false,
      operationList: [{
        label: "打为季度"
      }, {
        label: "打为充值"
      },
      // { label: "打为民宿" },
      {
        label: "取消认证"
      }],
      current: null
    };
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    onOpen: function onOpen() {
      this.current = null;
    },
    onClose: function onClose() {},
    close: function close() {
      this.$emit("update:visible", false);
    },
    handelConfirm: function handelConfirm() {
      if (this.current === 2) {
        // 取消认证
        this.setHouseAuthStatus();
      } else if (this.current === 0) {
        // 打为季度
        this.setUserType(3);
      } else if (this.current === 1) {
        // 打为充值
        this.setUserType(1);
      }
      // else if (this.current === 2) {
      //     // 打为民宿
      //     this.setUserType(2);
      // }
    },
    itemClick: function itemClick(index) {
      this.current = index;
    },
    operationLogPush: function operationLogPush(houseId, userId) {
      // 操作上报
      this.$operationLog.push({
        code: "reject",
        houseId: houseId,
        userId: userId,
        operationType: "house"
      });
    },
    // 仅拒绝
    onlyRefuse: function onlyRefuse() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this.$confirm("确认操作, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                var loading;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      _this.operationLogPush(_this.houseId, _this.userId);
                      console.log(_this.houseId);
                      loading = _this.$loading(); // return
                      _context.n = 1;
                      return _this.$api.auditHouse({
                        house_id: _this.houseId,
                        status: 6 // 拒绝6
                      });
                    case 1:
                      loading.close();
                      _this.$message.success("操作成功");
                      _this.close();
                      _this.$emit("refresh");
                    case 2:
                      return _context.a(2);
                  }
                }, _callee);
              }))).catch(function () {});
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    // 0：取消认证
    setHouseAuthStatus: function setHouseAuthStatus(noConfirm) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var loading, title, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              loading = _this2.$loading();
              title = "";
              if (!_this2.houseId) {
                _context5.n = 3;
                break;
              }
              _context5.n = 1;
              return _this2.$api.checkHouseAuth({
                house_id: _this2.houseId
              });
            case 1:
              res = _context5.v;
              if (!(res.data.user_is_audit > 0)) {
                _context5.n = 2;
                break;
              }
              loading.close();
              _this2.$message.closeAll();
              _this2.$message.error("该用户有房源在实名/认证过程中，请先处理后再操作");
              return _context5.a(2, Promise.resolve(true));
            case 2:
              if (res.data.house_is_auth > 0) {
                title = "该房源已实名/认证，是否继续操作？";
              }
              if (res.data.user_is_auth > 0) {
                title = "该用户已实名/认证，是否继续操作？";
              }
            case 3:
              loading.close();
              if (!title) {
                _context5.n = 6;
                break;
              }
              if (!noConfirm) {
                _context5.n = 5;
                break;
              }
              _context5.n = 4;
              return _this2.$api.setHouseAuthStatus({
                house_id: _this2.houseId,
                need_auth: 0
              });
            case 4:
              return _context5.a(2);
            case 5:
              _this2.$confirm(title, "\u8BBE\u4E3A\u53D6\u6D88\u8BA4\u8BC1", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "error"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _context3.n = 1;
                      return _this2.$api.setHouseAuthStatus({
                        house_id: _this2.houseId,
                        need_auth: 0
                      });
                    case 1:
                      _this2.$message.success("操作成功");
                      _this2.close();
                      _this2.$emit("refresh");
                    case 2:
                      return _context3.a(2);
                  }
                }, _callee3);
              }))).catch(function () {});
              _context5.n = 9;
              break;
            case 6:
              if (!noConfirm) {
                _context5.n = 8;
                break;
              }
              _context5.n = 7;
              return _this2.$api.setHouseAuthStatus({
                house_id: _this2.houseId,
                need_auth: 0
              });
            case 7:
              return _context5.a(2);
            case 8:
              _this2.$confirm("确认操作， 是否继续?", "\u8BBE\u4E3A\u53D6\u6D88\u8BA4\u8BC1", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "success"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      _context4.n = 1;
                      return _this2.$api.setHouseAuthStatus({
                        house_id: _this2.houseId,
                        need_auth: 0
                      });
                    case 1:
                      _this2.$message.success("操作成功");
                      _this2.close();
                      _this2.$emit("refresh");
                    case 2:
                      return _context4.a(2);
                  }
                }, _callee4);
              }))).catch(function () {});
            case 9:
              _this2.operationLogPush(_this2.houseId, _this2.userId);
            case 10:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    // 切换用户类型  1：品牌(充值)，2：民宿 3:季度
    setUserType: function setUserType(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var userTypeObj, loading, authStatus, title, res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              userTypeObj = {
                1: "充值",
                2: "民宿",
                3: "季度"
              };
              loading = _this3.$loading();
              _context8.n = 1;
              return _this3.$api.auditHouse({
                house_id: _this3.houseId,
                status: 6 // 拒绝6
              });
            case 1:
              _context8.n = 2;
              return _this3.setHouseAuthStatus(true);
            case 2:
              authStatus = _context8.v;
              // console.log(authStatus)
              // return
              title = "";
              if (!_this3.houseId) {
                _context8.n = 5;
                break;
              }
              _context8.n = 3;
              return _this3.$api.checkHouseAuth({
                house_id: _this3.houseId
              });
            case 3:
              res = _context8.v;
              if (!(res.data.user_is_audit > 0)) {
                _context8.n = 4;
                break;
              }
              loading.close();
              !authStatus && _this3.$message.error("该用户有房源在实名/认证过程中，请先处理后再操作");
              return _context8.a(2, Promise.resolve(true));
            case 4:
              if (res.data.house_is_auth > 0) {
                title = "该房源已实名/认证，是否继续操作？";
              }
              if (res.data.user_is_auth > 0) {
                title = "该用户已实名/认证，是否继续操作？";
              }
            case 5:
              loading.close();
              if (title) {
                _this3.$confirm(title, "\u8BBE\u4E3A".concat(userTypeObj[type]), {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "error"
                }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
                  return _regenerator().w(function (_context6) {
                    while (1) switch (_context6.n) {
                      case 0:
                        _context6.n = 1;
                        return _this3.$api.setUserType({
                          user_id: _this3.userId,
                          user_type: type
                        });
                      case 1:
                        _this3.$message.success("操作成功");
                        _this3.close();
                        _this3.$emit("refresh");
                      case 2:
                        return _context6.a(2);
                    }
                  }, _callee6);
                }))).catch(function () {});
              } else {
                _this3.$confirm("确认操作， 是否继续?", "\u8BBE\u4E3A".concat(userTypeObj[type]), {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "success"
                }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
                  return _regenerator().w(function (_context7) {
                    while (1) switch (_context7.n) {
                      case 0:
                        _context7.n = 1;
                        return _this3.$api.setUserType({
                          user_id: _this3.userId,
                          user_type: type
                        });
                      case 1:
                        _this3.$message.success("操作成功");
                        _this3.close();
                        _this3.$emit("refresh");
                      case 2:
                        return _context7.a(2);
                    }
                  }, _callee7);
                }))).catch(function () {});
              }
              _this3.operationLogPush(_this3.houseId, _this3.userId);
            case 6:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    }
  }
};